import config from "../config";

export default function useFileHelper() {
  //file size validation - should not be more than 1MB
  const isFileSizeValid = (file) => {
    return file.size <= config.file_upload_length;
  };

  //file type must be jpg, jpeg or png
  const isValidPicture = (file) => {
    const name = file.name;
    let reg = /(.*?)\.(jpg|jpeg|png)$/;

    return name.match(reg);
  };

  return {
    isFileSizeValid,
    isValidPicture,
  };
}